export default {
  open: false,
  rememberMe: false,
  email: '',
  password: '',
  errorMessage: '',
  loading: false,
  googlePromptInProcess: false,
};
